import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { BillingPlanIds } from '../../../../../enums/billing-plan-ids';

import { useIsSellerOnFeatureGatedPlanProfile } from '../../../../../feature-gates/use-is-seller-on-feature-gated-plan-profile';
import Global from '../../../../../store/global-selectors';
import { useManageSubscriptionDrawerContext } from '../../context/manage-subscription-drawer-context';

export const PlanGridConfig = {
  GbbLineup: 'gbb-lineup',
  StandardLegacy: 'standard-legacy',
} as const;

export type PlanGridConfigType = (typeof PlanGridConfig)[keyof typeof PlanGridConfig];

type SectionVisibility = {
  planGridConfig: PlanGridConfigType;
  canMigrate: boolean;
  shouldForceNewestPlans: boolean;
};

export const useManageSubscriptionDrawerSectionVisibility = (): SectionVisibility => {
  const isNewLineupPlanGridEnabled = useIsSellerOnFeatureGatedPlanProfile();
  const { canMigrate, isMigratingToNewestPlans, shouldForceNewestPlans = false } = useManageSubscriptionDrawerContext();
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);

  const { currentBillingPlan } = subscriptionData ?? {};
  const currentBillingPlanId = currentBillingPlan?.billingPlanId;

  return useMemo(() => {
    const isTrialSeller = currentBillingPlanId === BillingPlanIds.Trial.toString();

    const shouldShowNewLineupPlanGrid = isNewLineupPlanGridEnabled || isMigratingToNewestPlans || shouldForceNewestPlans || isTrialSeller;

    let planGridConfig: PlanGridConfigType;
    if (shouldShowNewLineupPlanGrid) {
      planGridConfig = PlanGridConfig.GbbLineup;
    } else {
      planGridConfig = PlanGridConfig.StandardLegacy;
    }

    return {
      planGridConfig,
      canMigrate,
      shouldForceNewestPlans,
    };
  }, [isNewLineupPlanGridEnabled, canMigrate, shouldForceNewestPlans, isMigratingToNewestPlans, currentBillingPlanId]);
};
